// Libs
import _ from "lodash";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React, { Component } from "react";
import { connect } from "react-redux";

// Components/Containers
import Breadcrumb from "../../components/Breadcrumb";
import LoadingBox from "../../components/LoadingBox";
import NotFoundBox from "../../components/NotFoundBox";
import Pagination from "../../components/Pagination";
import SpCaseErrorMessage from "./components/SpCaseErrorMessage";
import SpCasePageConfirm from "./components/SpCasePageConfirm";
import SpCasePageMessages from "./components/SpCasePageMessages";
import SpCasePageMoreInfos from "./components/SpCasePageMoreInfos";

// Normalize
import * as certificates from "../../constants/certificates";

// Actions
import { downloadFile } from "../App/actions";
import { changeConfig, toggleVisible } from "../ClickSign/actions";
import {
  actionChat,
  changeCheckout,
  changeConfirm,
  changeMoreInfos,
  changeMoreInfosComment,
  changeMoreInfosVisible,
  changeSpCase,
  createInviteChannel,
  downloadContract,
  fetchArchiveReasons,
  fetchSpCase,
  pingChat,
  saveMoreInfos,
  saveMoreInfosComment,
  uploadContract,
  validateFile,
} from "./actions";

// Imgs
import notFoundImg from "../../assets/not-found.svg";

// Axios Cancelation
import { uploadContractCancel } from "./actions";

import withParams from "../../hoc/WithParams";

class SpCasePage extends Component {
  state = {
    intervalId: null,
    errorMessage: null,
  };

  UNSAFE_componentWillMount() {
    const {
      user: { id, role },
      paramsSpCase,
      channel,
      fetchSpCase,
      fetchArchiveReasons,
      createInviteChannel,
      history,
    } = this.props;

    const spCaseId = paramsSpCase;

    if (channel) {
      createInviteChannel(paramsSpCase, channel);
      history.push(`/meus-casos/${paramsSpCase}`);
    }

    fetchSpCase(id, role, spCaseId);
    fetchArchiveReasons();
  }

  componentDidMount() {
    const intervalId = setInterval(() => {
      const {
        user: { id },
        ping,
        spCase,
        pingChat,
        paramsDebug,
      } = this.props;
      const spCaseId = spCase.id;

      if (ping && !_.isEmpty(spCase.chat)) {
        let lastMessageId = spCase.chat.slice(-1)[0].id;
        if (lastMessageId || lastMessageId === 0) {
          return pingChat(id, spCaseId, lastMessageId);
        } else {
          lastMessageId = spCase.chat.slice(-1)[0][0].id - 1;
          return pingChat(id, spCaseId, lastMessageId);
        }
      }
    }, 3000);

    this.setState({ intervalId });

    window.scroll({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  }

  componentDidUpdate(prevProps) {
    const {
      user,
      spCase: { id, agreedValue, hadObligation, chat },
      checkout,
      paramsSpCase,
      changeCheckout,
      fetchSpCase,
    } = this.props;
    const prevId = prevProps.spCase.id;
    const prevChat = prevProps.spCase.chat;

    if (
      prevId !== undefined &&
      String(id).toUpperCase() !== String(paramsSpCase).toUpperCase()
    ) {
      fetchSpCase(user.id, user.role, paramsSpCase);
    }

    if (chat !== prevChat) {
      window.scroll({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }

    // Allow actions if checkout already made
    if (
      !checkout &&
      (agreedValue == 0 || agreedValue) &&
      hadObligation !== null
    ) {
      changeCheckout(true);
    }
  }

  componentWillUnmount() {
    const { intervalId } = this.state;

    clearInterval(intervalId);
  }

  handleDownload = (fileRequest, minutaId) => {
    const { spCase, downloadFile } = this.props;
    const spCaseId = spCase.id;

    downloadFile(spCaseId, fileRequest, minutaId);
  };

  handleUpload = (type, files) => {
    const { changeConfirm } = this.props;
    let headline = "";
    let buttonTitle1 = "";

    switch (type) {
      case "minuta":
        headline = "Você está prestes a anexar a minuta abaixo:";
        buttonTitle1 = "Anexar Minuta";
        break;
      case "protocolo":
        headline = "Você está prestes a anexar o protocolo abaixo:";
        buttonTitle1 = "Anexar Protocolo";
        break;
      default:
    }

    const visible = true;
    const action = `upload ${type}`;
    const buttonTitle2 = "Voltar";
    const file = files[0];

    changeConfirm(
      visible,
      action,
      headline,
      {},
      buttonTitle1,
      buttonTitle2,
      file,
      null
    );
  };

  handleStart = () => {
    const { user, spCase, actionChat } = this.props;
    const id = user.id;
    const spCaseId = spCase.id;
    const action = "start";

    actionChat(id, spCaseId, action);
  };

  handleNew = (text, lawyer, company, status) => {
    const {
      user: { role },
      proposalConfirmation,
    } = this.props;
    let messageName = role === "lawyer" ? lawyer.name : company.name;
    let date = new Date();
    let hour = new Date();

    date = `${date.getDate()}/${("0" + date.getMonth()).slice(
      -2
    )}/${date.getFullYear()}`;
    hour = `${hour.getHours()}:${hour.getMinutes()}`;

    const { changeConfirm } = this.props;
    const visible = true;
    const action = "new";
    const headline =
      status === 3
        ? "Você está prestes a enviar a mensagem abaixo:"
        : "Você está prestes a enviar a proposta abaixo:";
    const message = {
      name: messageName,
      status: 2,
      date,
      hour,
      text,
      createBy: role,
    };
    const buttonTitle1 =
      status === 3
        ? "Enviar Mensagem"
        : proposalConfirmation
        ? "Próximo Passo"
        : "Enviar Proposta";
    const buttonTitle2 = status === 3 ? "Voltar" : "Voltar a Negociar";

    changeConfirm(
      visible,
      action,
      headline,
      message,
      buttonTitle1,
      buttonTitle2,
      {},
      null
    );
  };

  handleAccept = (chatMessage, lawyer, company) => {
    let messageName =
      chatMessage.createBy === "lawyer" ? lawyer.name : company.name;

    const { changeConfirm } = this.props;
    const visible = true;
    const action = "accept";
    const headline = "Você está prestes a aceitar a proposta abaixo:";
    const message = { ...chatMessage, name: messageName };
    const buttonTitle1 = "Aceitar Proposta";
    const buttonTitle2 = "Voltar a Negociar";

    changeConfirm(
      visible,
      action,
      headline,
      message,
      buttonTitle1,
      buttonTitle2,
      null,
      null
    );
  };

  handleDecline = (chatMessage, lawyer, company) => {
    let messageName =
      chatMessage.createBy === "lawyer" ? lawyer.name : company.name;

    const { changeConfirm } = this.props;
    const visible = true;
    const action = "archive-reason";
    const headline = (
      <p>
        Você está prestes a encerrar esta negociação, mas a{" "}
        <span>empresa ainda está esperando sua contraproposta.</span> Que tal
        enviá-la agora?
        <br />É só clicar em "Voltar a Negociar" e, depois, em "Enviar
        Contraproposta".
      </p>
    );
    const buttonTitle1 = "Prefiro Encerrar";
    const buttonTitle2 = "Voltar a Negociar";

    changeConfirm(
      visible,
      action,
      headline,
      {},
      buttonTitle1,
      buttonTitle2,
      null,
      null
    );
  };

  handleCheckout = () => {
    const { changeConfirm } = this.props;

    const visible = true;
    const action = "checkout";
    const headline =
      "Antes de habilitarmos suas próximas ações, precisamos confirmar...";
    const buttonTitle1 = "Confirmar";
    const buttonTitle2 = "Voltar";

    changeConfirm(
      visible,
      action,
      headline,
      {},
      buttonTitle1,
      buttonTitle2,
      null,
      null
    );
  };

  handleFinish = (minutaId) => {
    const { spCase, downloadFile, downloadContract, changeConfirm } =
      this.props;
    const spCaseId = spCase.id;

    const visible = true;
    const action = "finish";
    const headline = "Você está prestes a aceitar esta minuta";
    const buttonTitle1 = "Aceitar Minuta";
    const buttonTitle2 = "Voltar";

    downloadContract(spCaseId, "minuta", minutaId);
    changeConfirm(
      visible,
      action,
      headline,
      {},
      buttonTitle1,
      buttonTitle2,
      null,
      minutaId
    );
  };

  handlePrint = () => {
    const { spCase } = this.props;
    const attemptCertificate = certificates.attempt(spCase);

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.createPdf(attemptCertificate).open();
  };

  handleConfirm = (
    message,
    action,
    file,
    minutaId,
    agreedValue,
    hadObligation,
    archiveReason,
    archiveObservation,
    expectedValue,
    proposalValue,
    noProposal
  ) => {
    const {
      user: { id, role, email, name, surname, lawFirmId, admin },
      spCase,
      changeConfirm,
      actionChat,
      uploadContract,
      proposalConfirmation,
    } = this.props;
    const spCaseId = spCase.id;

    // Delighted
    if (action === "archive" || action === "upload minuta" || !admin) {
      const surveyRole =
        role === "lawyer" ? "lawyer" : !lawFirmId ? "company" : "lawFirm";

      window.delighted.survey({
        email,
        name: `${name} ${surname}`,
        properties: {
          userId: id,
          role: surveyRole,
        },
        initialDelay: 0,
      });
    }

    if (action === "upload minuta") {
      uploadContract(id, spCaseId, "minuta", file);
    } else if (action === "upload protocolo") {
      uploadContract(id, spCaseId, "protocolo", file);
    } else if (action === "archive-reason") {
      const visible = true;
      const action = "archive-observation";
      const headline = "Selecione o motivo do encerramento: \n";
      const buttonTitle1 = "Prosseguir";
      const buttonTitle2 = "Voltar a Negociar";

      changeConfirm(
        visible,
        action,
        headline,
        {},
        buttonTitle1,
        buttonTitle2,
        null,
        null
      );
    } else if (action === "archive-observation") {
      const visible = true;
      const action = "archive";
      const buttonTitle1 = "Encerrar Negociação";
      const buttonTitle2 = "Voltar a Negociar";
      let headline =
        'Gostaria de complementar o motivo do encerramento? \nAo clicar em "Encerrar Negociação" você não poderá voltar a negociar este caso.';

      // Ask for expected value
      if (role === "lawyer" && archiveReason === 6) {
        headline = (
          <p>
            Por favor, a fim de{" "}
            <span>melhorarmos a política de negociação</span> de nossas
            empresas, qual seria o <span>menor valor</span> pelo qual estaria
            disposto a <span>fechar um acordo</span>?
          </p>
        );
      }

      changeConfirm(
        visible,
        action,
        headline,
        {},
        buttonTitle1,
        buttonTitle2,
        null,
        null
      );
    } else if (
      action === "new" &&
      proposalConfirmation &&
      spCase.status !== 3
    ) {
      const visible = true;
      const action = "proposal-confirmation";
      const buttonTitle1 = "Enviar Proposta";
      const buttonTitle2 = "Voltar";
      let headline = "";

      changeConfirm(
        visible,
        action,
        headline,
        message,
        buttonTitle1,
        buttonTitle2,
        null,
        null
      );
    } else {
      let proposal = proposalConfirmation || !noProposal ? proposalValue : null;
      actionChat(
        id,
        spCaseId,
        action,
        message,
        null,
        minutaId,
        agreedValue,
        hadObligation,
        archiveReason,
        archiveObservation,
        expectedValue,
        proposal
      );
    }
  };

  handleUnarchive = () => {
    const { changeConfirm } = this.props;
    const visible = true;
    const action = "unarchive";
    const headline = "Você está prestes a desarquivar o caso.";
    const buttonTitle1 = "Confirmar";
    const buttonTitle2 = "Voltar";

    changeConfirm(
      visible,
      action,
      headline,
      {},
      buttonTitle1,
      buttonTitle2,
      null,
      null
    );
  };

  render() {
    const {
      localLoading,
      upload,
      download,
      user,
      loading,
      spCase,
      confirm,
      moreInfos,
      clickSign,
      checkout,
      archiveReasons,
      paramsSpCase,
      proposalConfirmation,
      changeConfirm,
      changeMoreInfosVisible,
      changeMoreInfos,
      changeMoreInfosComment,
      saveMoreInfos,
      saveMoreInfosComment,
    } = this.props;
    const {
      state: { errorMessage },
      handleDownload,
      handleUpload,
      handleStart,
      handleNew,
      handleAccept,
      handleDecline,
      handleCheckout,
      handleFinish,
      handlePrint,
      handleClickSign,
      handleConfirm,
      handleUnarchive,
    } = this;

    return (
      <div className="sp-case-page">
        {/* <Params /> */}
        {/* <div className='sp-case-page__header'> */}
        <Breadcrumb routes={["meus-casos", paramsSpCase]} />
        {/* <div className='sp-case-page__header__navegation'>
            <span> <ArrowLeft size={12} /> Anterior</span>
            <span> Próximo <ArrowRight size={12} /></span>
          </div>
        </div> */}
        <Pagination
          page="sp-case"
          leftActionIsVisible={moreInfos.visible}
          infoText={`Exibindo Caso`}
          onSelect={() => changeMoreInfosVisible(!moreInfos.visible)}
        />
        {!loading && !_.isEmpty(spCase.chat) && (
          <div>
            <SpCasePageMessages
              upload={upload}
              download={download}
              user={user}
              spCase={spCase}
              checkout={checkout}
              handleDownload={handleDownload}
              handleUpload={handleUpload}
              handleStart={handleStart}
              handleNew={handleNew}
              handleAccept={handleAccept}
              handleDecline={handleDecline}
              handleCheckout={handleCheckout}
              handleFinish={handleFinish}
              handleClickSign={handleClickSign}
              handlePrint={handlePrint}
              handleUnarchive={handleUnarchive}
              validateFile={validateFile}
              validateFileError={(msg) => this.setState({ errorMessage: msg })}
            />
            <SpCasePageConfirm
              localLoading={localLoading}
              user={user}
              confirm={confirm}
              archiveReasons={archiveReasons}
              handleConfirm={handleConfirm}
              spCase={spCase}
              proposalConfirmation={proposalConfirmation}
              handleContinue={(action) => {
                changeConfirm(false, action, "", {}, "", "", null);
                action === "upload" && uploadContractCancel();
              }}
            />
            <SpCaseErrorMessage
              visible={errorMessage !== null}
              message={errorMessage}
              handleClose={() => this.setState({ errorMessage: null })}
            />
          </div>
        )}
        {!loading && _.isEmpty(spCase.chat) && (
          <NotFoundBox
            img={notFoundImg}
            title={`O caso ${paramsSpCase} não existe na plataforma.`}
            text="Em caso de dúvida, entre em contato com o nosso suporte no chat abaixo ao lado direito."
          />
        )}
        {loading && <LoadingBox />}
        <SpCasePageMoreInfos
          visible={moreInfos.visible}
          user={user}
          spCase={spCase}
          handleOpen={() => changeMoreInfosVisible(true)}
          handleClose={() => changeMoreInfosVisible(false)}
          handleChange={(field, value) => changeMoreInfos(field, value)}
          handleSave={() =>
            saveMoreInfos(
              spCase.id,
              spCase.maxValue,
              spCase.provision,
              spCase.ps,
              spCase.deadline
            )
          }
          handleCommentChange={(e) => changeMoreInfosComment(e.target.value)}
          handleCommentBlur={(e) =>
            saveMoreInfosComment(spCase.id, user.id, e.target.value)
          }
        />
      </div>
    );
  }
}

SpCasePage = connect(
  (state, ownProps) => ({
    localLoading: state.app.localLoading,
    upload: state.app.upload,
    download: state.app.download,
    user: state.auth.user,
    loading: state.spCasePage.loading,
    ping: state.spCasePage.ping,
    spCase: state.spCasePage.spCase,
    confirm: state.spCasePage.confirm,
    moreInfos: state.spCasePage.moreInfos,
    clickSign: state.spCasePage.clickSign,
    comment: state.spCasePage.comment,
    checkout: state.spCasePage.checkout,
    archiveReasons: state.spCasePage.archiveReasons,
    paramsSpCase: ownProps.params.spCase,
    channel: ownProps.params.channel,
    proposalConfirmation: state.spCasePage.spCase.group.proposalConfirmation,
  }),
  {
    downloadFile,
    toggleVisible,
    changeConfig,
    actionChat,
    changeSpCase,
    changeConfirm,
    changeMoreInfosVisible,
    changeMoreInfos,
    changeMoreInfosComment,
    changeCheckout,
    fetchSpCase,
    pingChat,
    downloadContract,
    uploadContract,
    saveMoreInfos,
    saveMoreInfosComment,
    fetchArchiveReasons,
    createInviteChannel,
  }
)(SpCasePage);

export default withParams(SpCasePage);
